import { createUseStyles } from '@glu/theming';

export default createUseStyles(({
  nav: {
    userLink
  }
}) => ({
  container: {
    textAlign: 'left'
  },
  subText: {
    fontSize: userLink.subTextFontSize,
    margin: userLink.subTextMargin,

    '& strong': {
      fontWeight: 700,
      textTransform: 'uppercase'
    }
  },
  userLink: {
    margin: [3, 0],
    lineHeight: 1,
    padding: userLink.padding,
    alignItems: 'flex-start'
  }
}));
